module.exports = __webpack_public_path__ + "img/couples_08_V.15d87af6.webp";